<section [class.visible]="visible" id="about">

    <div class="container d-flex">
        <div class="half d-flex align-top justify-center">
            <div #checkpoint class="left">
                <h2 class="f-light f-upper" [class.dencapsulate]="animate || mobile" [innerHTML]="encapsulate(content[language].about.hat)"></h2>
                <h3 class="f-light f-upper" [class.dencapsulate]="animate || mobile" [innerHTML]="encapsulate(content[language].about.title)"></h3>

                <div class="text f-light" [class.animate]="animate" [innerHTML]="content[language].about.text">
                </div>
            </div>
        </div>

        <div class="half">
            <div #right class="right ready d-flex" [class.animate]="animate" [style.top]="((1 - offsetscroll) * 30) + 'rem'">
                <owl-carousel-o #large
                    class="large"
                    [options]="largeOptions"
                    [class.animate]="animate"
                    (changed)="translated($event)">
                    <ng-template carouselSlide *ngFor="let item of content[language].about.gallery">
                        <img src="assets/content/{{ item.large }}" alt="{{ item.legend }}">
                    </ng-template>
                </owl-carousel-o>
            </div>

            <owl-carousel-o #small
                class="gallery desktop"
                [options]="smallOptions"
                [class.animate]="animate"
                [style.bottom]="(offsetscroll * 10) + 'rem'"
                (changed)="translated($event)">
                <ng-template carouselSlide *ngFor="let item of content[language].about.gallery">
                    <img src="assets/content/{{ item.small }}" alt="{{ item.legend }}">
                    <svg class="progress-ring" width="3.5rem" height="3.5rem">
                        <circle class="progress-ring__circle" stroke="white" stroke-width="0.6rem" fill="transparent" r="1.45rem" cx="1.75rem" cy="1.75rem"
                            stroke-dasharray="calc(1.45rem * 2 * 3.141592653589793)"
                            [attr.stroke-dashoffset]="'calc((1.45rem * 2 * 3.141592653589793) - ' + percent + ' / 100 * calc(1.45rem * 2 * 3.141592653589793))'" />
                    </svg>
                    <div class="progress-control" [class.stopped]="! controlIt" (click)="control()"></div>
                </ng-template>
            </owl-carousel-o>
            
            <div class="gallery-counter f-light f-center desktop" [style.bottom]="(offsetscroll * 10) + 'rem'">
                {{ slidePosition }} / {{ content[language].about.gallery.length }}
            </div>

            <owl-carousel-o
                class="gallery mobile"
                [options]="smallOptions"
                [class.animate]="animate"
                [style.bottom]="(offsetscroll * 10) + 'rem'"
                (changed)="translatedMobile($event)">
                <ng-template carouselSlide *ngFor="let item of content[language].about.gallery">
                        <img src="assets/content/{{ item.small }}" alt="{{ item.legend }}">
                </ng-template>

                <ng-template carouselSlide *ngFor="let item of content[language].about.gallery">
                    <img src="assets/content/{{ item.large }}" alt="{{ item.legend }}" [class.bottom]="item.bottom">
                </ng-template>
            </owl-carousel-o>
            
            <div class="gallery-counter f-light f-center mobile" [style.bottom]="(offsetscroll * 10) + 'rem'">
                {{ slidePositionMobile }} / {{ content[language].about.gallery.length * 2 }}
            </div>
        </div>
    </div>

</section>

<section #checkpointVideo id="video" class="video">

    <div class="thumb" [class.stop]="! playing" [class.animate]="animateVideo" (click)="video(); playing = true">
        <img src="assets/content/{{ content[language].about.video.thumb }}" width="1280px" height="720px" *ngIf="! playing">
        <iframe width="1280px" height="720px" [src]="videoLink" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen *ngIf="playing"></iframe>
    </div>

</section>